angular.module('ui.bootstrap.datetimepicker', [
        'ui.bootstrap.dateparser', 'ui.bootstrap.position',
        'template/datetimepicker/datetimepicker.html', 'template/datetimepicker/day.html',
        'template/datetimepicker/time.html',
		'template/datetimepicker/popup.html'
])
    .constant('datetimepickerConfig', {
        //datepicker
        formatDay: 'dd',
        formatMonth: 'MMMM',
        formatYear: 'yyyy',
        formatDayHeader: 'EEE',
        formatDayTitle: 'MMMM yyyy',
        formatMonthTitle: 'yyyy',
        datepickerMode: 'day',
        minMode: 'day',
        maxMode: 'year',
        showWeeks: true,
        startingDay: 0,
        yearRange: 20,
        minDate: null,
        maxDate: null,
        shortcutPropagation: false,

        //timepicker
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        meridians: null,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true,
        showSpinners: true,

        //extra
        showTime: true,
        showDate: true,

        datetimepickerMode: 'day'
    })
    .controller('DatetimepickerController', [
        '$scope', '$attrs', '$parse', '$interpolate', '$timeout', '$log', '$locale', 'dateFilter', 'datetimepickerConfig',
        function ($scope, $attrs, $parse, $interpolate, $timeout, $log, $locale, dateFilter, datetimepickerConfig) {
            var self = this,
                ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl;

            // Modes chain
            this.modes = ['time', 'day', 'month', 'year'];

            // Configuration attributes
            angular.forEach([
                'formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle',
                   'showWeeks', 'startingDay', 'yearRange', 'shortcutPropagation', /*custom*/ 'showTime', 'showDate'
            ], function (key, index) {
                self[key] = angular.isDefined($attrs[key]) ? (index < 6 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key])) : datetimepickerConfig[key];
            });

            // Watchable date attributes
            angular.forEach(['minDate', 'maxDate'], function (key) {
                if ($attrs[key]) {
                    $scope.$parent.$watch($parse($attrs[key]), function (value) {
                        self[key] = value ? new Date(value) : null;
                        self.refreshView();
                    });
                } else {
                    self[key] = datetimepickerConfig[key] ? new Date(datetimepickerConfig[key]) : null;
                }
            });
            angular.forEach(['minMode', 'maxMode'], function (key) {
                if ($attrs[key]) {
                    $scope.$parent.$watch($parse($attrs[key]), function (value) {
                        self[key] = angular.isDefined(value) ? value : $attrs[key];
                        $scope[key] = self[key];
                        if ((key == 'minMode' && self.modes.indexOf($scope.datetimepickerMode) < self.modes.indexOf(self[key])) || (key == 'maxMode' && self.modes.indexOf($scope.datetimepickerMode) > self.modes.indexOf(self[key]))) {
                            $scope.datetimepickerMode = self[key];
                        }
                    });
                } else {
                    self[key] = datetimepickerConfig[key] || null;
                    $scope[key] = self[key];
                }
            });

            $scope.showTime = self.showTime;
            $scope.showDate = self.showDate;
            angular.forEach(['showTime', 'showDate'], function (key) {
                if ($attrs[key]) {
                    $scope.$parent.$watch($parse($attrs[key]), function (value) {
                        $scope[key] = value;
                        if (key == 'showTime') {
                            self.minMode = value ? 'time' : 'day';
                            if (self.modes.indexOf($scope.datetimepickerMode) < self.modes.indexOf(self.minMode)) {
                                $scope.datetimepickerMode = self.minMode;
                            }
                        }
                        else if (key == 'showDate') {
                            self.maxMode = value ? 'year' : 'time';
                            if (self.modes.indexOf($scope.datetimepickerMode) > self.modes.indexOf(self.maxMode)) {
                                $scope.datetimepickerMode = self.maxMode;
                            }
                        }
                        self.refreshView();
                    });
                }
            });

            $scope.datetimepickerMode = $scope.datetimepickerMode || datetimepickerConfig.datetimepickerMode;
            $scope.uniqueId = 'datetimepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
            this.activeDate = angular.isDefined($attrs.initDate) ? $scope.$parent.$eval($attrs.initDate) : new Date();

            $scope.isActive = function (dateObject) {
                if (self.compare(dateObject.date, self.activeDate) === 0) {
                    $scope.activeDateId = dateObject.uid;
                    return true;
                }
                return false;
            };

            this.init = function (ngModelCtrl_) {
                ngModelCtrl = ngModelCtrl_;

                ngModelCtrl.$render = function () {
                    self.render();
                };
            };

            this.render = function () {
                if (ngModelCtrl.$modelValue) {
                    var date = new Date(ngModelCtrl.$modelValue),
                        isValid = !isNaN(date);

                    if (isValid) {
                        this.activeDate = date;
                    } else {
                        $log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
                    }
                    ngModelCtrl.$setValidity('date', isValid);
                    ngModelCtrl.$setValidity('time', isValid);
                }
                this.refreshView();
            };

            this.refreshView = function () {
                if (this.element) {
                    this._refreshView();

                    var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : null;
                    ngModelCtrl.$setValidity('date-disabled', !date || (this.element && !this.isDisabled(date)));
                }
            };

            this.createDateObject = function (date, format) {
                var model = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : null;
                return {
                    date: date,
                    label: dateFilter(date, format),
                    selected: model && this.compare(date, model) === 0,
                    disabled: this.isDisabled(date),
                    current: this.compare(date, new Date()) === 0,
                    customClass: this.customClass(date)
                };
            };

            this.isDisabled = function (date) {
                return ((this.minDate && this.compare(date, this.minDate) < 0) || (this.maxDate && this.compare(date, this.maxDate) > 0) || ($attrs.dateDisabled && $scope.dateDisabled({ date: date, mode: $scope.datetimepickerMode })));
            };

            this.customClass = function (date) {
                return $scope.customClass({ date: date, mode: $scope.datetimepickerMode });
            };

            // Split array into smaller arrays
            this.split = function (arr, size) {
                var arrays = [];
                while (arr.length > 0) {
                    arrays.push(arr.splice(0, size));
                }
                return arrays;
            };

            // Fix a hard-reprodusible bug with timezones
            // The bug depends on OS, browser, current timezone and current date
            // i.e.
            // var date = new Date(2014, 0, 1);
            // console.log(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours());
            // can result in "2013 11 31 23" because of the bug.
            this.fixTimeZone = function (date) {
                var hours = date.getHours();
                date.setHours(hours === 23 ? hours + 2 : 0);
            };

            $scope.select = function (date) {
                if ($scope.datetimepickerMode == 'day' || $scope.datetimepickerMode === self.minMode) {
                    var dt = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date(0, 0, 0, 0, 0, 0, 0);
                    dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
                    ngModelCtrl.$setViewValue(dt);
                    ngModelCtrl.$render();
                } else {
                    self.activeDate = date;
                    $scope.datetimepickerMode = self.modes[self.modes.indexOf($scope.datetimepickerMode) - 1];
                }
            };

            $scope.move = function (direction) {
                var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
                    month = self.activeDate.getMonth() + direction * (self.step.months || 0);
                self.activeDate.setFullYear(year, month, 1);
                self.refreshView();
            };

            $scope.toggleMode = function (direction) {
                direction = direction || 1;

                if (($scope.datetimepickerMode === self.maxMode && direction === 1) || ($scope.datetimepickerMode === self.minMode && direction === -1)) {
                    return;
                }

                $scope.datetimepickerMode = self.modes[self.modes.indexOf($scope.datetimepickerMode) + direction];
            };

            // Key event mapper
            $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

            var focusElement = function () {
                $timeout(function () {
                    self.element[0].focus();
                }, 0, false);
            };

            // Listen for focus requests from popup directive
            $scope.$on('datetimepicker.focus', focusElement);

            $scope.keydown = function (evt) {
                var key = $scope.keys[evt.which];

                if (!key || evt.shiftKey || evt.altKey) {
                    return;
                }

                evt.preventDefault();
                if (!self.shortcutPropagation) {
                    evt.stopPropagation();
                }

                if (key === 'enter' || key === 'space') {
                    if (self.isDisabled(self.activeDate)) {
                        return; // do nothing
                    }
                    $scope.select(self.activeDate);
                    focusElement();
                } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
                    $scope.toggleMode(key === 'up' ? 1 : -1);
                    focusElement();
                } else {
                    self.handleKeyDown(key, evt);
                    self.refreshView();
                }
            };


            //TIMEPICKER
            var meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : datetimepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS;

            var time = $scope.time = {};

            this.initTime = function (ngModelCtrl_, inputs) {
                ngModelCtrl = ngModelCtrl_;
                ngModelCtrl.$formatters.unshift(function (modelValue) {
                    return modelValue ? new Date(modelValue) : null;
                });

                var hoursInputEl = inputs.eq(0),
                    minutesInputEl = inputs.eq(1);

                var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : datetimepickerConfig.mousewheel;
                if (mousewheel) {
                    this.setupMousewheelEvents(hoursInputEl, minutesInputEl);
                }
                var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : datetimepickerConfig.arrowkeys;
                if (arrowkeys) {
                    this.setupArrowkeyEvents(hoursInputEl, minutesInputEl);
                }

                time.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : datetimepickerConfig.readonlyInput;
                this.setupInputEvents(hoursInputEl, minutesInputEl);
            };

            var hourStep = datetimepickerConfig.hourStep;
            if ($attrs.hourStep) {
                $scope.$parent.$watch($parse($attrs.hourStep), function (value) {
                    hourStep = parseInt(value, 10);
                });
            }

            var minuteStep = datetimepickerConfig.minuteStep;
            if ($attrs.minuteStep) {
                $scope.$parent.$watch($parse($attrs.minuteStep), function (value) {
                    minuteStep = parseInt(value, 10);
                });
            }

            var min;
            $scope.$parent.$watch($parse($attrs.min), function (value) {
                var dt = new Date(value);
                min = isNaN(dt) ? undefined : dt;
            });

            var max;
            $scope.$parent.$watch($parse($attrs.max), function (value) {
                var dt = new Date(value);
                max = isNaN(dt) ? undefined : dt;
            });

            time.noIncrementHours = function () {
                var incrementedSelected = addMinutes(self.activeDate, hourStep * 60);
                return incrementedSelected > max ||
				(incrementedSelected < self.activeDate && incrementedSelected < min);
            };

            time.noDecrementHours = function () {
                var decrementedSelected = addMinutes(self.activeDate, -hourStep * 60);
                return decrementedSelected < min ||
				(decrementedSelected > self.activeDate && decrementedSelected > max);
            };

            time.noIncrementMinutes = function () {
                var incrementedSelected = addMinutes(self.activeDate, minuteStep);
                return incrementedSelected > max ||
				(incrementedSelected < self.activeDate && incrementedSelected < min);
            };

            time.noDecrementMinutes = function () {
                var decrementedSelected = addMinutes(self.activeDate, -minuteStep);
                return decrementedSelected < min ||
				(decrementedSelected > self.activeDate && decrementedSelected > max);
            };

            time.noToggleMeridian = function () {
                if (self.activeDate.getHours() < 13) {
                    return addMinutes(self.activeDate, 12 * 60) > max;
                } else {
                    return addMinutes(self.activeDate, -12 * 60) < min;
                }
            };

            // 12H / 24H mode
            time.showMeridian = datetimepickerConfig.showMeridian;
            if ($attrs.showMeridian) {
                $scope.$parent.$watch($parse($attrs.showMeridian), function (value) {
                    time.showMeridian = !!value;

                    if (ngModelCtrl.$error.time) {
                        // Evaluate from template
                        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
                        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
                            self.activeDate.setHours(hours);
                            self.refreshTime();
                        }
                    } else {
                        self.updateTimeTemplate();
                    }
                });
            }

            // Get $scope.hours in 24H mode if valid
            function getHoursFromTemplate() {
                var hours = parseInt(time.hours, 10);
                var valid = (time.showMeridian) ? (hours > 0 && hours < 13) : (hours >= 0 && hours < 24);
                if (!valid) {
                    return undefined;
                }

                if (time.showMeridian) {
                    if (hours === 12) {
                        hours = 0;
                    }
                    if (time.meridian === meridians[1]) {
                        hours = hours + 12;
                    }
                }
                return hours;
            }

            function getMinutesFromTemplate() {
                var minutes = parseInt(time.minutes, 10);
                return (minutes >= 0 && minutes < 60) ? minutes : undefined;
            }

            function pad(value) {
                return (angular.isDefined(value) && value.toString().length < 2) ? '0' + value : value;
            }

            // Respond on mousewheel spin
            this.setupMousewheelEvents = function (hoursInputEl, minutesInputEl) {
                var isScrollingUp = function (e) {
                    if (e.originalEvent) {
                        e = e.originalEvent;
                    }
                    //pick correct delta variable depending on event
                    var delta = (e.wheelDelta) ? e.wheelDelta : -e.deltaY;
                    return (e.detail || delta > 0);
                };

                hoursInputEl.bind('mousewheel wheel', function (e) {
                    $scope.$apply((isScrollingUp(e)) ? time.incrementHours() : time.decrementHours());
                    e.preventDefault();
                });

                minutesInputEl.bind('mousewheel wheel', function (e) {
                    $scope.$apply((isScrollingUp(e)) ? time.incrementMinutes() : time.decrementMinutes());
                    e.preventDefault();
                });

            };

            // Respond on up/down arrowkeys
            this.setupArrowkeyEvents = function (hoursInputEl, minutesInputEl) {
                hoursInputEl.bind('keydown', function (e) {
                    if (e.which === 38) { // up
                        e.preventDefault();
                        time.incrementHours();
                        $scope.$apply();
                    } else if (e.which === 40) { // down
                        e.preventDefault();
                        time.decrementHours();
                        $scope.$apply();
                    }
                });

                minutesInputEl.bind('keydown', function (e) {
                    if (e.which === 38) { // up
                        e.preventDefault();
                        time.incrementMinutes();
                        $scope.$apply();
                    } else if (e.which === 40) { // down
                        e.preventDefault();
                        time.decrementMinutes();
                        $scope.$apply();
                    }
                });
            };

            this.setupInputEvents = function (hoursInputEl, minutesInputEl) {
                if (time.readonlyInput) {
                    time.updateHours = angular.noop;
                    time.updateMinutes = angular.noop;
                    return;
                }

                var invalidate = function (invalidHours, invalidMinutes) {
                    ngModelCtrl.$setViewValue(null);
                    ngModelCtrl.$setValidity('time', false);
                    if (angular.isDefined(invalidHours)) {
                        time.invalidHours = invalidHours;
                    }
                    if (angular.isDefined(invalidMinutes)) {
                        time.invalidMinutes = invalidMinutes;
                    }
                };

                time.updateHours = function () {
                    var hours = getHoursFromTemplate(),
					minutes = getMinutesFromTemplate();

                    if (angular.isDefined(hours) && angular.isDefined(minutes)) {
                        self.activeDate.setHours(hours);
                        if (self.activeDate < min || self.activeDate > max) {
                            invalidate(true);
                        } else {
                            self.refreshTime('h');
                        }
                    } else {
                        invalidate(true);
                    }
                };

                hoursInputEl.bind('blur', function (e) {
                    if (!time.invalidHours && time.hours < 10) {
                        $scope.$apply(function () {
                            time.hours = pad(time.hours);
                        });
                    }
                });

                time.updateMinutes = function () {
                    var minutes = getMinutesFromTemplate(),
					hours = getHoursFromTemplate();

                    if (angular.isDefined(minutes) && angular.isDefined(hours)) {
                        self.activeDate.setMinutes(minutes);
                        if (self.activeDate < min || self.activeDate > max) {
                            invalidate(undefined, true);
                        } else {
                            self.refreshTime('m');
                        }
                    } else {
                        invalidate(undefined, true);
                    }
                };

                minutesInputEl.bind('blur', function (e) {
                    if (!time.invalidMinutes && time.minutes < 10) {
                        $scope.$apply(function () {
                            time.minutes = pad(time.minutes);
                        });
                    }
                });

            };

            // Call internally when we know that model is valid.
            this.refreshTime = function (keyboardChange) {
                self.makeValidTime();
                ngModelCtrl.$setViewValue(new Date(self.activeDate));
                self.updateTimeTemplate(keyboardChange);
            };

            this.makeValidTime = function () {
                ngModelCtrl.$setValidity('time', true);
                time.invalidHours = false;
                time.invalidMinutes = false;
            };

            this.updateTimeTemplate = function (keyboardChange) {
                var hours = self.activeDate.getHours(), minutes = self.activeDate.getMinutes();

                if (time.showMeridian) {
                    hours = (hours === 0 || hours === 12) ? 12 : hours % 12; // Convert 24 to 12 hour system
                }

                time.hours = keyboardChange === 'h' ? hours : pad(hours);
                time.minutes = keyboardChange === 'm' ? minutes : pad(minutes);
                time.meridian = self.activeDate.getHours() < 12 ? meridians[0] : meridians[1];
            };

            function addMinutes(date, minutes) {
                var dt = new Date(date.getTime() + minutes * 60000);
                var newDate = new Date(date);
                newDate.setHours(dt.getHours(), dt.getMinutes());
                return newDate;
            }

            function addMinutesToSelected(minutes) {
                self.activeDate = addMinutes(self.activeDate, minutes);
                self.refreshTime();
            }

            $scope.showSpinners = angular.isDefined($attrs.showSpinners) ? $scope.$parent.$eval($attrs.showSpinners)
				: datetimepickerConfig.showSpinners;

            time.incrementHours = function () {
                if (!time.noIncrementHours()) {
                    addMinutesToSelected(hourStep * 60);
                }
            };
            time.decrementHours = function () {
                if (!time.noDecrementHours()) {
                    addMinutesToSelected(-hourStep * 60);
                }
            };
            time.incrementMinutes = function () {
                if (!time.noIncrementMinutes()) {
                    addMinutesToSelected(minuteStep);
                }
            };
            time.decrementMinutes = function () {
                if (!time.noDecrementMinutes()) {
                    addMinutesToSelected(-minuteStep);
                }
            };
            time.toggleMeridian = function () {
                if (!time.noToggleMeridian()) {
                    addMinutesToSelected(12 * 60 * (self.activeDate.getHours() < 12 ? 1 : -1));
                }
            };
        }
    ])
    .directive('datetimepicker', function () {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: 'template/datetimepicker/datetimepicker.html',
            scope: {
                datetimepickerMode: '=?',
                dateDisabled: '&',
                customClass: '&',
                shortcutPropagation: '&?'
            },
            require: ['datetimepicker', '^ngModel'],
            controller: 'DatetimepickerController',
            link: function (scope, element, attrs, ctrls) {
                var dtpickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                dtpickerCtrl.init(ngModelCtrl);
            }
        };
    })
    .directive('dtTimepicker', ['$timeout',
        function ($timeout) {
            return {
                restrict: 'EA',
                require: ['^datetimepicker', '?^ngModel'],
                replace: true,
                templateUrl: 'template/datetimepicker/time.html',
                link: function (scope, element, attrs, ctrls) {
                    var dtpickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                    var inputs = element.find('input');
                    dtpickerCtrl.step = {};
                    dtpickerCtrl.element = element;

                    dtpickerCtrl._refreshView = function () {
                        dtpickerCtrl.makeValidTime();
                        dtpickerCtrl.updateTimeTemplate();
                    };
                    dtpickerCtrl.compare = function (date1, date2) {
                        return date1.getFullYear() - date2.getFullYear();
                    };

                    dtpickerCtrl.handleKeyDown = function (key, evt) {
                        if (evt.target.nodeName.toLowerCase() !== 'input') {
                            if (key == 'left') {
                                $timeout(function () {
                                    inputs.last().focus();
                                });
                            } else if (key == 'right') {
                                $timeout(function () {
                                    inputs.first().focus();
                                });
                            }
                            return;
                        }
                        var input = $(evt.target);
                        var part = input.data('part');
                        /*
                        if (key == 'up') {
                            if(part == 'hour') {
                                scope.time.incrementHours();
                            } else {
                                scope.time.incrementMinutes();
                            }
                        } else if (key == 'down') {
                            if(part == 'hour') {
                                scope.time.decrementHours();
                            } else {
                                scope.time.decrementMinutes();
                            }
                        } else*/ if (key == 'left' || key == 'right') {
                            $timeout(function () {
                                inputs.not(evt.target).focus();
                            });
                        }
                    };

                    dtpickerCtrl.initTime(ngModelCtrl, inputs);
                    dtpickerCtrl.refreshView();
                }
            };
        }
    ])
    .directive('dtDaypicker', [
        'daypickerDirective', function (daypickerDirective) {
            var dir = angular.extend({}, daypickerDirective['0']);
            dir.name = 'dtDaypicker';
            dir.templateUrl = 'template/datetimepicker/day.html';
            dir.require = '^datetimepicker';

            return dir;
        }
    ])
    .directive('dtMonthpicker', [
        'monthpickerDirective', function (monthpickerDirective) {
            var dir = angular.extend({}, monthpickerDirective['0']);
            dir.name = 'dtMonthpicker';
            dir.require = '^datetimepicker';

            return dir;
        }
    ])
    .directive('dtYearpicker', [
        'yearpickerDirective', function (yearpickerDirective) {
            var dir = angular.extend({}, yearpickerDirective['0']);
            dir.name = 'dtYearpicker';
            dir.require = '^datetimepicker';

            return dir;
        }
    ])
    .constant('datetimepickerPopupConfig', {
        datetimepickerPopup: 'yyyy-MM-dd',
        datetimepickerPopupTemplateUrl: 'template/datetimepicker/popup.html',
        datetimepickerTemplateUrl: 'template/datetimepicker/datetimepicker.html',
        html5Types: {
            date: 'yyyy-MM-dd',
            'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
            'month': 'yyyy-MM'
        },
        currentText: 'Current',
        clearText: 'Clear',
        closeText: 'Done',
        closeOnDateSelection: false,
        appendToBody: false,
        showButtonBar: true,
        onOpenFocus: true
    })
    .controller('DatetimepickerPopupInputGroupCtrl', [
        '$scope', function ($scope) {
            $scope.$dtp = {
                toggle: function ($event, name) {
                    $event.preventDefault();
                    $event.stopPropagation();

                    if (!this.models[name]) {
                        this.models[name] = {};
                    }
                    this.models[name].opened = !this.models[name].opened;
                },
                models: {}
            };
        }
    ])
    .directive('datetimepickerPopup', [
        '$compile', '$parse', '$document', '$rootScope', '$position', '$timeout', 'dateFilter', 'dateParser', 'datetimepickerPopupConfig',
        function ($compile, $parse, $document, $rootScope, $position, $timeout, dateFilter, dateParser, datetimepickerPopupConfig) {
            return {
                restrict: 'EA',
                require: 'ngModel',
                scope: {
                    isOpen: '=?',
                    currentText: '@',
                    clearText: '@',
                    closeText: '@',
                    dateDisabled: '&',
                    customClass: '&',
                    openOnFocus: '@'
                },
                link: function (scope, element, attrs, ngModel) {
                    var dateFormat,
                        closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$parent.$eval(attrs.closeOnDateSelection) : datetimepickerPopupConfig.closeOnDateSelection,
                        appendToBody = angular.isDefined(attrs.datepickerAppendToBody) ? scope.$parent.$eval(attrs.datepickerAppendToBody) : datetimepickerPopupConfig.appendToBody,
						onOpenFocus = angular.isDefined(attrs.onOpenFocus) ? scope.$parent.$eval(attrs.onOpenFocus) : datetimepickerPopupConfig.onOpenFocus,
						datetimepickerPopupTemplateUrl = angular.isDefined(attrs.datetimepickerPopupTemplateUrl) ? attrs.datetimepickerPopupTemplateUrl : datetimepickerPopupConfig.datetimepickerPopupTemplateUrl,
						datetimepickerTemplateUrl = angular.isDefined(attrs.datetimepickerTemplateUrl) ? attrs.datetimepickerTemplateUrl : datetimepickerPopupConfig.datetimepickerTemplateUrl;

                    scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ? scope.$parent.$eval(attrs.showButtonBar) : datetimepickerPopupConfig.showButtonBar;

                    scope.getText = function (key) {
                        return scope[key + 'Text'] || datetimepickerPopupConfig[key + 'Text'];
                    };

                    var isHtml5DateInput = false;
                    if (datetimepickerPopupConfig.html5Types[attrs.type]) {
                        dateFormat = datetimepickerPopupConfig.html5Types[attrs.type];
                        isHtml5DateInput = true;
                    } else {
                        dateFormat = attrs.datetimepickerPopup || datetimepickerPopupConfig.datetimepickerPopup;
                        attrs.$observe('datetimepickerPopup', function (value, oldValue) {
                            var newDateFormat = value || datetimepickerPopupConfig.datetimepickerPopup;
                            // Invalidate the $modelValue to ensure that formatters re-run
                            // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
                            if (newDateFormat !== dateFormat) {
                                dateFormat = newDateFormat;
                                ngModel.$modelValue = null;

                                if (!dateFormat) {
                                    throw new Error('datetimepickerPopup must have a date format specified.');
                                }
                            }
                        });
                    }

                    if (!dateFormat) {
                        new Error('datepickerPopup must have a date format specified.');
                    }

                    if (isHtml5DateInput && attrs.datepickerPopup) {
                        throw new Error('HTML5 date input types do not support custom formats.');
                    }

                    // popup element used to display calendar
                    var popupEl = angular.element('<div datetimepicker-popup-wrap><div datetimepicker></div></div>');
                    popupEl.attr({
                        'ng-model': 'date',
                        'ng-change': 'dateSelection(date)',
                        'template-url': datetimepickerPopupTemplateUrl
                    });

                    function cameltoDash(string) {
                        return string.replace(/([A-Z])/g, function ($1) { return '-' + $1.toLowerCase(); });
                    }

                    // datepicker element
                    var datepickerEl = angular.element(popupEl.children()[0]);
                    datepickerEl.attr('template-url', datetimepickerTemplateUrl);

                    if (isHtml5DateInput) {
                        if (attrs.type == 'month') {
                            datepickerEl.attr('datetimepicker-mode', '"month"');
                            datepickerEl.attr('min-mode', 'month');
                        }
                    }

                    if (attrs.datepickerOptions) {
                        var options = scope.$parent.$eval(attrs.datepickerOptions);
                        if (options && options.initDate) {
                            scope.initDate = options.initDate;
                            datepickerEl.attr('init-date', 'initDate');
                            delete options.initDate;
                        }
                        angular.forEach(options, function (value, option) {
                            datepickerEl.attr(cameltoDash(option), value);
                        });
                    }

                    scope.watchData = {
                        showTime: true,
                        showDate: true,
                    };
                    datepickerEl.attr('show-time', 'watchData.showTime');
                    datepickerEl.attr('show-date', 'watchData.showDate');

                    angular.forEach(['minMode', 'maxMode', 'minDate', 'maxDate', 'datetimepickerMode', 'initDate', 'shortcutPropagation'], function (key) {
                        if (attrs[key]) {
                            var getAttribute = $parse(attrs[key]);
                            scope.$parent.$watch(getAttribute, function (value) {
                                scope.watchData[key] = value;
                            });
                            datepickerEl.attr(cameltoDash(key), 'watchData.' + key);

                            // Propagate changes from datepicker to outside
                            if (key === 'datetimepickerMode') {
                                var setAttribute = getAttribute.assign;
                                scope.$watch('watchData.' + key, function (value, oldvalue) {
                                    if (value !== oldvalue) {
                                        setAttribute(scope.$parent, value);
                                    }
                                });
                            }
                        }
                    });

                    if (attrs.dateDisabled) {
                        datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
                    }

                    if (attrs.showWeeks) {
                        datepickerEl.attr('show-weeks', attrs.showWeeks);
                    }

                    if (attrs.customClass) {
                        datepickerEl.attr('custom-class', 'customClass({ date: date, mode: mode })');
                    }

                    function parseDate(viewValue) {
                        if (angular.isNumber(viewValue)) {
                            // presumably timestamp to date object
                            viewValue = new Date(viewValue);
                        }

                        if (!viewValue) {
                            return null;
                        } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
                            return viewValue;
                        } else if (angular.isString(viewValue)) {
                            var date = dateParser.parse(viewValue, dateFormat, scope.date);
                            if (isNaN(date)) {
                                return undefined;
                            } else {
                                return date;
                            }
                        } else {
                            return undefined;
                        }
                    }

                    /*
                    function parseDate(viewValue) {
                        if (!viewValue) {
                            ngModel.$setValidity('date', true);
                            return null;
                        } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
                            ngModel.$setValidity('date', true);
                            return viewValue;
                        } else if (angular.isString(viewValue)) {
                            var date = dateParser.parse(viewValue, dateFormat) || new Date(viewValue);
                            if (isNaN(date)) {
                                ngModel.$setValidity('date', false);
                                return undefined;
                            } else {
                                ngModel.$setValidity('date', true);
                                return date;
                            }
                        } else {
                            ngModel.$setValidity('date', false);
                            return undefined;
                        }
                    }*/

                    function validator(modelValue, viewValue) {
                        var value = modelValue || viewValue;

                        if (!attrs.ngRequired && !value) {
                            return true;
                        }

                        if (angular.isNumber(value)) {
                            value = new Date(value);
                        }
                        if (!value) {
                            return true;
                        } else if (angular.isDate(value) && !isNaN(value)) {
                            return true;
                        } else if (angular.isString(value)) {
                            var date = dateParser.parse(value, dateFormat);
                            return !isNaN(date);
                        } else {
                            return false;
                        }
                    }

                    if (!isHtml5DateInput) {
                        // Internal API to maintain the correct ng-invalid-[key] class
                        ngModel.$$parserName = 'date';
                        ngModel.$validators.date = validator;
                        ngModel.$parsers.unshift(parseDate);
                        ngModel.$formatters.push(function (value) {
                            scope.date = value;
                            return ngModel.$isEmpty(value) ? value : dateFilter(value, dateFormat);
                        });
                    } else {
                        ngModel.$formatters.push(function (value) {
                            scope.date = value;
                            return value;
                        });
                    }

                    /*
                    // Inner change
                    scope.dateSelection = function(dt) {
                        if (angular.isDefined(dt)) {
                            scope.date = dt;
                        }
                        ngModel.$setViewValue(scope.date);
                        ngModel.$render();

                        if (closeOnDateSelection) {
                            scope.isOpen = false;
                            element[0].focus();
                        }
                    };*/

                    // Inner change
                    scope.dateSelection = function (dt) {
                        if (angular.isDefined(dt)) {
                            scope.date = dt;
                        }
                        var date = scope.date ? dateFilter(scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
                        element.val(date);
                        ngModel.$setViewValue(date);

                        if (closeOnDateSelection) {
                            scope.isOpen = false;
                            element[0].focus();
                        }
                    };


                    // Detect changes in the view from the text box
                    ngModel.$viewChangeListeners.push(function () {
                        scope.date = dateParser.parse(ngModel.$viewValue, dateFormat, scope.date);
                    });

                    var documentClickBind = function (event) {
                        if (scope.isOpen && !element[0].contains(event.target)) {
                            scope.$apply(function () {
                                scope.isOpen = false;
                            });
                        }
                    };

                    var canOpenOnFocus = true;
                    var focus = function (evt) {
                        if (!canOpenOnFocus) {
                            canOpenOnFocus = true;
                            return;
                        }
                        $timeout(function () {
                            scope.isOpen = true;
                        });
                    };
                    var blur = function (evt) {
                        $timeout(function () {
                            scope.isOpen = false;
                        });
                    };

                    if (scope.openOnFocus) {
                        element.bind('focus', focus);
                        //element.bind('blur', blur);
                    }

                    var inputKeydownBind = function (evt) {
                        if ((evt.which === 27) && scope.isOpen) {
                            canOpenOnFocus = false;
                            evt.preventDefault();
                            evt.stopPropagation();
                            scope.$apply(function () {
                                scope.isOpen = false;
                            });
                            element[0].focus();
                        } else if (evt.which === 40 && !scope.isOpen) {
                            evt.preventDefault();
                            evt.stopPropagation();
                            scope.$apply(function () {
                                scope.isOpen = true;
                            });
                        } else if (evt.which === 9 && scope.isOpen) {
                            canOpenOnFocus = true;
                            scope.$apply(function () {
                                scope.isOpen = false;
                            });
                        }
                    };
                    element.bind('keydown', inputKeydownBind);

                    scope.keydown = function (evt) {
                        if (evt.which === 27) {
                            scope.isOpen = false;
                            element[0].focus();
                            scope.close();
                        }
                    };

                    scope.$watch('isOpen', function (value) {
                        if (value) {
                            scope.position = appendToBody ? $position.offset(element) : $position.position(element);
                            scope.position.top = scope.position.top + element.prop('offsetHeight');

                            $timeout(function () {
                                if (onOpenFocus) {
                                    scope.$broadcast('datepicker.focus');
                                }
                                $document.bind('click', documentClickBind);
                            }, 0, false);
                        } else {
                            $document.unbind('click', documentClickBind);
                        }
                    });

                    scope.select = function (date) {
                        if (date === 'today') {
                            var today = new Date();
                            if (angular.isDate(scope.date)) {
                                date = new Date(scope.date);
                                date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
                                date.setHours(today.getHours(), today.getMinutes(), today.getSeconds());
                            } else {
                                date = new Date();
                            }
                        }
                        scope.dateSelection(date);
                    };
                    scope.close = function () {
                        scope.isOpen = false;
                        if (!scope.openOnFocus)
                            element[0].focus();
                    };

                    var $popup = $compile(popupEl)(scope);
                    // Prevent jQuery cache memory leak (template is now redundant after linking)
                    popupEl.remove();

                    if (appendToBody) {
                        $document.find('body').append($popup);
                    } else {
                        element.after($popup);
                    }

                    scope.$on('$destroy', function () {
                        if (scope.isOpen === true) {
                            if (!$rootScope.$$phase) {
                                scope.$apply(function () {
                                    scope.isOpen = false;
                                });
                            }
                        }

                        $popup.remove();
                        element.unbind('keydown', inputKeydownBind);
                        $document.unbind('click', documentClickBind);
                    });

                    var isEnabled = function (granularity) {
                        if (typeof granularity !== 'string' || granularity.length > 1) {
                            throw new TypeError('isEnabled expects a single character string parameter');
                        }
                        switch (granularity) {
                            case 'y':
                                return dateFormat.indexOf('Y') !== -1;
                            case 'M':
                                return dateFormat.indexOf('M') !== -1;
                            case 'd':
                                return dateFormat.toLowerCase().indexOf('d') !== -1;
                            case 'h':
                            case 'H':
                                return dateFormat.toLowerCase().indexOf('h') !== -1;
                            case 'm':
                                return dateFormat.indexOf('m') !== -1;
                            case 's':
                                return dateFormat.indexOf('s') !== -1;
                            default:
                                return false;
                        }
                    };

                    var hasTime = function () {
                        return (isEnabled('h') || isEnabled('m') || isEnabled('s'));
                    };

                    var hasDate = function () {
                        return (isEnabled('y') || isEnabled('M') || isEnabled('d'));
                    };

                    attrs.$observe('datetimepickerPopup', function (value) {
                        dateFormat = value || datetimepickerPopupConfig.datetimepickerPopup;
                        scope.watchData.showTime = hasTime();
                        scope.watchData.showDate = hasDate();
                        ngModel.$render();
                    });




                }
            };
        }
    ])
    .directive('datetimepickerPopupWrap', function () {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'template/datetimepicker/popup.html';
            }
        };
    });

angular.module("template/datetimepicker/datetimepicker.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("template/datetimepicker/datetimepicker.html",
      "<div ng-switch=\"datetimepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n" +
      "    <dt-timepicker ng-switch-when=\"time\" tabindex=\"0\"></dt-timepicker>\n" +
      "    <dt-daypicker ng-switch-when=\"day\" tabindex=\"0\"></dt-daypicker>\n" +
      "    <dt-monthpicker ng-switch-when=\"month\" tabindex=\"0\"></dt-monthpicker>\n" +
      "    <dt-yearpicker ng-switch-when=\"year\" tabindex=\"0\"></dt-yearpicker>\n" +
      "</div>");
}]);

angular.module("template/datetimepicker/day.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("template/datetimepicker/day.html",
      "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
      "  <thead>\n" +
      "    <tr>\n" +
      "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
      "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
      "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
      "    </tr>\n" +
      "    <tr>\n" +
      "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
      "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
      "    </tr>\n" +
      "  </thead>\n" +
      "  <tbody>\n" +
      "    <tr ng-repeat=\"row in rows track by $index\">\n" +
      "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
      "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\">\n" +
      "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default btn-sm\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
      "      </td>\n" +
      "    </tr>\n" +
      "  </tbody>\n" +
      "    <tfoot ng-if=\"showTime\">\n" +
      "        <tr>\n" +
      "            <td colspan=\"{{:: 7 + showWeeks}}\">\n" +
      "                <div calss=\"text-center\" style=\"padding:10px 9px 2px\">\n" +
      "                    <a ng-click=\"toggleMode(-1)\" class=\"btn btn-link\" style=\"width:100%\"><span class=\"glyphicon glyphicon-time\"></span></a>\n" +
      "                </div>\n" +
      "            </td>\n" +
      "        </tr>\n" +
      "    </tfoot>\n" +
      "</table>");
}]);

angular.module("template/datetimepicker/popup.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("template/datetimepicker/popup.html",
      "<ul class=\"dropdown-menu\" ng-if=\"isOpen\" style=\"display: block;z-index: 9999;\" ng-style=\"{top: position.top+'px', left: position.left+'px'}\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
      "	<li ng-transclude></li>\n" +
      "	<li ng-if=\"showButtonBar\" style=\"padding:10px 9px 2px\">\n" +
      "		<span class=\"btn-group pull-left\">\n" +
      "			<button type=\"button\" class=\"btn btn-sm btn-info\" ng-click=\"select('today')\">{{ getText('current') }}</button>\n" +
      "			<button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"select(null)\">{{ getText('clear') }}</button>\n" +
      "		</span>\n" +
      "		<button type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"close()\">{{ getText('close') }}</button>\n" +
      "	</li>\n" +
      "</ul>");
}]);

angular.module("template/datetimepicker/time.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("template/datetimepicker/time.html",
      "<table class=\"text-center\" style=\"margin: 20px;\">\n" +
      "    <thead>\n" +
      "        <tr>\n" +
      "            <td colspan=\"5\">\n" +
      "                <div class=\"text-center\" style=\"padding:10px 9px 2px\">\n" +
      "                    <a ng-click=\"toggleMode()\" class=\"btn btn-link\" style=\"width:100%\"><span class=\"glyphicon glyphicon-calendar\"></span></a>\n" +
      "                </div>\n" +
      "            </td>\n" +
      "        </tr>\n" +
      "    </thead>\n" +
      "    <tbody>\n" +
      "        <tr>\n" +
      "            <td><a ng-click=\"time.incrementHours()\" ng-class=\"{disabled: time.noIncrementHours()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
      "            <td>&nbsp;</td>\n" +
      "            <td><a ng-click=\"time.incrementMinutes()\" ng-class=\"{disabled: time.noIncrementMinutes()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
      "            <td>&nbsp;</td>\n" +
      "            <td ng-show=\"time.showMeridian\"></td>\n" +
      "        </tr>\n" +
      "        <tr>\n" +
      "            <td style=\"width:50px;\"  class=\"form-group\" ng-class=\"{'has-error': time.invalidHours}\">\n" +
      "                <input style=\"width:50px;\" type=\"text\" ng-model=\"time.hours\" data-part=\"hour\" ng-change=\"time.updateHours()\" class=\"form-control text-center\" ng-mousewheel=\"time.incrementHours()\" ng-readonly=\"::time.readonlyInput\" maxlength=\"2\">\n" +
      "            </td>\n" +
      "            <td style=\"width:50px;\">:</td>\n" +
      "            <td style=\"width:50px;\" class=\"form-group\" ng-class=\"{'has-error': time.invalidMinutes}\">\n" +
      "                <input style=\"width:50px;\" type=\"text\" ng-model=\"time.minutes\" data-part=\"minute\" ng-change=\"time.updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::time.readonlyInput\" maxlength=\"2\">\n" +
      "            </td>\n" +
      "            <td style=\"width:20px;\">&nbsp;</td>\n" +
      "            <td style=\"width:50px;\" ng-show=\"time.showMeridian\" ><button type=\"button\" class=\"btn btn-primary text-center\" ng-click=\"time.toggleMeridian()\">{{time.meridian}}</button></td>\n" +
      "        </tr>\n" +
      "        <tr class=\"text-center\">\n" +
      "            <td><a ng-click=\"time.decrementHours()\" ng-class=\"{disabled: time.noDecrementHours()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
      "            <td>&nbsp;</td>\n" +
      "            <td><a ng-click=\"time.decrementMinutes()\" ng-class=\"{disabled: time.noDecrementMinutes()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
      "            <td>&nbsp;</td>\n" +
      "            <td ng-show=\"time.showMeridian\"></td>\n" +
      "        </tr>\n" +
      "    </tbody>\n" +
      "</table>");
}]);
